import * as React from 'react';
import { Popover as PopoverPrimitive } from 'radix-ui';
import { PopoverContentProps } from '@radix-ui/react-popover';
import styles from './popover.module.css';
import { cn } from '../../utils';

export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverAnchor = PopoverPrimitive.Anchor;

export const PopoverContent = React.forwardRef<
  HTMLDivElement,
  PopoverContentProps & { showArrow?: boolean; arrowClassName?: string }
>(({ children, showArrow, arrowClassName, ...props }, forwardedRef) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      {...props}
      ref={forwardedRef}
      className={cn(styles.popover, props.className)}
    >
      {children}
      {showArrow && (
        <PopoverPrimitive.Arrow
          asChild
          {...(arrowClassName ? { className: arrowClassName } : undefined)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="8"
            viewBox="0 0 15 8"
            fill="none"
          >
            <path d="M7.60156 0L14.5011 7.8995L7.60156 7.8995L0.702067 7.8995L7.60156 0Z" />
          </svg>
        </PopoverPrimitive.Arrow>
      )}
    </PopoverPrimitive.Content>
  </PopoverPrimitive.Portal>
));
